import { logout } from 'user'

export const OuterLayout = {
  view({ children }) {
    return m('div', children)
  }
}

export const Layout = {
  view({ children }) {
    return m(OuterLayout
      , m('button', { class: 'btn', onclick: logout }, 'Logout') // TODO better injection into header?
      , children)
  }
}

export default Layout
